export default "/dist/files/icone_faune.bd5540c8f60e90962737e01ccbf5f209.svg";